<template>
  <div
    v-if="text"
    class="qr-code-container"
  >
    <img
      class="qr-code-img"
      :src="qrImg"
    >
    <slot>
      <div
        v-if="hint"
        class="qr-code-hint"
        v-html="hint"
      />
    </slot>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'HKLQRCode',
  props: {
    text: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    imgWidth: {
      type: Number,
      default: 120,
    },
  },
  data () {
    return {
      qrImg: '',
    }
  },
  async mounted () {
    if (this.text) {
      this.qrImg = await QRCode.toDataURL(this.text, {
        width: this.imgWidth,
        margin: 1,
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.qr-code-container {
  width: 100%;
  text-align: center;
  .qr-code-hint {
    font-style: italic;
    color: #878787;
    display: inline-block;
  }
}

</style>
